// theme-toggle.js — bascule jour/nuit avec persistance.
//
// Source de vérité :
//   1. 'nb-theme' (localStorage, par device) — lu par le FOUC script dans <head>.
//   2. Firestore via LAgendaAuth.setTheme() — sync cross-device quand l'user
//      est connecté. Le snapshot reécrit `lagenda_theme_${uid}` en local ;
//      on réapplique alors le thème reçu et on remet nb-theme à jour.
//
// Le bouton de toggle est le SEUL point d'entrée d'écriture : il écrit
// simultanément nb-theme (rapide, FOUC) + Firestore (cross-device) via
// LAgendaAuth.setTheme.
(function(){
'use strict';

const GLOBAL_KEY = 'nb-theme';

const root = document.documentElement;
const btn = document.getElementById('theme-toggle');

function updateLabel(theme){
  if (!btn) return;
  const lbl = btn.querySelector('.lbl');
  if (!lbl) return;
  // Le label indique le theme vers lequel on va basculer (action)
  lbl.textContent = theme === 'jour' ? 'Nuit' : 'Jour';
}

function currentTheme(){
  return root.getAttribute('data-theme') === 'jour' ? 'jour' : 'nuit';
}

function applyTheme(theme){
  if (theme === 'jour') root.setAttribute('data-theme', 'jour');
  else root.removeAttribute('data-theme');
  updateLabel(theme);
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme === 'jour' ? '#F4ECDE' : '#0A0805');
  try { localStorage.setItem(GLOBAL_KEY, theme); } catch(e) {}
}

updateLabel(currentTheme());

window.NightBureau = Object.assign(window.NightBureau || {}, {
  currentTheme,
});

if (btn) {
  btn.addEventListener('click', () => {
    const next = currentTheme() === 'jour' ? 'nuit' : 'jour';
    applyTheme(next);
    // Propage à Firestore (cross-device) quand connecté.
    // Sinon, LAgendaAuth.setTheme écrit dans lagenda_theme_anon.
    if (window.LAgendaAuth && window.LAgendaAuth.setTheme) {
      window.LAgendaAuth.setTheme(next);
    }
  });
}

// Sync depuis LAgendaAuth (cache user key hydraté + snapshots Firestore).
function syncFromAuth(){
  if (!window.LAgendaAuth) return;
  const get = window.LAgendaAuth.getTheme;
  if (typeof get === 'function') {
    const t = get();
    if ((t === 'jour' || t === 'nuit') && t !== currentTheme()) applyTheme(t);
  }
  if (typeof window.LAgendaAuth.onDataChange === 'function') {
    window.LAgendaAuth.onDataChange(({ theme }) => {
      if ((theme === 'jour' || theme === 'nuit') && theme !== currentTheme()) {
        applyTheme(theme);
      }
    });
  }
}

if (window.LAgendaAuth) syncFromAuth();
else window.addEventListener('lagenda-auth-ready', syncFromAuth, { once: true });

})();
